import { useCallback, useEffect, useState } from 'react';

type ScrollPosition = 'start' | 'center' | 'end' | 'none';

export function useScrollPosition(ref: React.RefObject<HTMLElement>) {
  const [scrollPosition, setScrollPosition] = useState<ScrollPosition>('none');
  const checkScrollPosition = useCallback(() => {
    if (!ref.current) return;
    if (
      ref.current.scrollWidth === ref.current.clientWidth &&
      ref.current.scrollHeight === ref.current.clientHeight
    ) {
      setScrollPosition('none');
    } else if (ref.current.scrollLeft < 1 && ref.current.scrollTop < 1) {
      setScrollPosition('start');
    } else if (
      ref.current.scrollWidth -
        ref.current.offsetWidth -
        ref.current.scrollLeft <
        1 &&
      ref.current.scrollHeight -
        ref.current.offsetHeight -
        ref.current.scrollTop <
        1
    ) {
      setScrollPosition('end');
    } else {
      setScrollPosition('center');
    }
  }, [ref]);

  useEffect(() => {
    checkScrollPosition();
    window.addEventListener('resize', checkScrollPosition);
    return () => window.removeEventListener('resize', checkScrollPosition);
  }, [checkScrollPosition]);

  return {
    /**
     * ---
     * An element's position within a scrollable container
     *
     * **one of:** `start | center | end` or
     * `none` if there is no overflow or scrollbar
     *
     * */
    scrollPosition,
    /**
     * **Usage:** `<div onScroll={handleScroll} />`
     * Retriggers a scroll position check
     * */
    handleScroll: checkScrollPosition,
  };
}
